import React from "react";

export default function NoSearchScreen({searchValue, cols}){
    return(
        <tr>
            <td
                colspan={cols}
                className="sm:text-center text-start sm:pl-0 xs:pl-[200px] pl-[100px]"
            >
                <div className="h-[180px] mt-[100px]">
                    <p className="text-[18px] font-medium  leading-normal text-[#34343" data-testid="no_search_results">
                        No search results for ‘{searchValue.length>30 ? 
                            searchValue.slice(0,30)+'...' : searchValue}’</p>
                </div>
            </td>
        </tr>
    )
}